import styles from "./Footer.module.css";
import { Row, Col, Nav } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

const links = [
  [
    { text: "Our company", href: "https://one.nz/our-company/" },
    {
      text: "Corporate responsibility",
      href: "https://one.nz/our-company/corporate-responsibility/",
    },
    {
      text: "Our executives",
      href: "https://one.nz/our-company/ceo-executive-team/",
    },
    { text: "Careers", href: "https://one.nz/careers/" },
    { text: "Legal", href: "https://one.nz/legal/" },
    { text: "One NZ", href: "https://one.nz/" },
  ],
  [
    { text: "Buying online", href: "https://one.nz/help/online-shop/" },
    {
      text: "Browse mobile phones",
      href: "https://one.nz/online-shop/mobile/product-listing/?_bc_fsnf=1&sort=featured&planType=onAccount",
    },
    {
      text: "Browse accessories",
      href: "https://one.nz/online-shop/accessory/product-listing/?_bc_fsnf=1&sort=featured",
    },
    {
      text: "Buy a SIM card",
      href: "https://one.nz/mobile-plans/buy-sim-card/",
    },
  ],
  [
    {
      text: "Popular Now",
      href: "https://one.nz/specials-promos/",
    },
    {
      text: "Samsung S26 Ultra",
      href: "https://one.nz/samsung-galaxy/galaxy-s26-ultra/",
    },
    {
      text: "Samsung S26+",
      href: "https://one.nz/samsung-galaxy/galaxy-s26-plus/",
    },
    {
      text: "Samsung S26",
      href: "https://one.nz/samsung-galaxy/galaxy-s26/",
    },
    {
      text: "iPhone 17 Pro Max",
      href: "https://one.nz/iphone/iphone-17-pro-max/",
    },
    {
      text: "iPhone 17 Pro",
      href: "https://one.nz/iphone/iphone-17-pro/",
    },
    {
      text: "iPhone 17",
      href: "https://one.nz/iphone/iphone-17/",
    },
    {
      text: "iPhone Air",
      href: "https://one.nz/iphone/iphone-air/",
    },
    {
      text: "Motorola edge 60 pro",
      href: "https://one.nz/motorola/edge-60-pro/",
    },
  ],
  [
    { text: "Contact us", href: "https://one.nz/contact/" },
    {
      text: "Call us",
      href: "https://one.nz/contact/#call",
    },
    {
      text: "Message us",
      href: "https://one.nz/contact/#message-us",
    },
    {
      text: "Give us feedback",
      href: "https://one.nz/contact/feedback/",
    },
    {
      text: "Find a store",
      href: "https://one.nz/help/store-locations/",
    },
  ],
  [{ text: "Switch to Personal", href: "https://one.nz" }],
  [
    {
      text: "Switch to Business",
      href: "https://one.nz/business/",
    },
  ],
];

export const Footer = () => {
  return (
    <Row className={styles.component}>
      {/* for screen >= 992px */}
      <Row className={[styles.footerRow, styles.hiddenOnSmScreen]}>
        {links.map((linkGroup, index) => (
          <Col md={4} key={index} className={styles.linkGroup}>
            <Nav className="flex-column">
              {linkGroup.map((linkItem, index) => (
                <Nav.Link
                  key={index}
                  href={linkItem.href}
                  className={index === 0 ? styles.superLink : styles.subLink}
                >
                  <span>{linkItem.text}</span>
                  {index === 0 && (
                    <span className={styles.superLinkChevron}>&rsaquo;</span>
                  )}
                </Nav.Link>
              ))}
            </Nav>
          </Col>
        ))}
      </Row>
      {/* for screen < 992px */}
      <Row className={[styles.footerRow, styles.smLinksBlock]}>
        <Col>
          <Accordion flush>
            {links.map((linkGroup, index) => (
              <Accordion.Item
                eventKey={index}
                key={index}
                className={styles.smLinkGroup}
              >
                <Accordion.Header className={styles.smLinkGroupHeader}>
                  <Nav.Link href={linkGroup[0].href}>
                    {linkGroup[0].text}
                  </Nav.Link>
                </Accordion.Header>
                {linkGroup.length > 1 && (
                  <Accordion.Body className={styles.smLinkGroupBody}>
                    {linkGroup.slice(1).map((linkItem, index) => (
                      <Nav.Link key={index} href={linkItem.href}>
                        {linkItem.text}
                      </Nav.Link>
                    ))}
                  </Accordion.Body>
                )}
              </Accordion.Item>
            ))}
          </Accordion>
        </Col>
      </Row>
      {/* always show copyright and T&Cs*/}
      <Row className={[styles.footerRow, "align-items-center"]}>
        <Col className="col-lg-7">
          <Nav>
            <Nav.Link href="https://one.nz/legal/terms-conditions/">
              Terms and conditions
            </Nav.Link>{" "}
            |
            <Nav.Link href="https://one.nz/legal/policy/privacy/">
              Privacy Policy
            </Nav.Link>{" "}
            |<Nav.Link href="https://one.nz/sitemap/">Sitemap</Nav.Link>
          </Nav>
        </Col>
        <Col className="col-12 col-lg-5 align-items-center">
          <Nav className={[styles.copyright, "justify-content-end"]}>
            <p>Copyright &copy; {new Date().getFullYear()} One New Zealand Group Limited</p>
          </Nav>
        </Col>
      </Row>
    </Row>
  );
};
